<template lang="html">

  <div v-if="isMobileScreen && routeAcceptsMobileScreen" class="back-button">

    <router-link v-for="(route, $index) in backButtons" :to="{ name: route.name }" :key="route.name">

      <el-tag :class="$route.name === route.name ? 'el-tag--success' : ''" v-if="$route.name !== route.name">
        <i v-for="index in (backButtons.length - $index - 1)" class="el-icon-arrow-left" v-if="$route.name !== route.name"></i>
        {{ namedRoutes && namedRoutes[route.name] ? namedRoutes[route.name] : route.meta.title }}
      </el-tag>

    </router-link>

  </div>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: [
    'namedRoutes',
  ],
  computed: {
    routeAcceptsMobileScreen() {
      return typeof this.$route.meta.onMobileScreen === 'object';
    },
    ...mapGetters({
      isMobileScreen: 'screen/isMobileScreen',
    }),
  },
  watch: {
    $route: 'checkRoutes',
  },
  data() {
    return {
      backButtons: [],
    };
  },
  methods: {
    checkRoutes() {
      if (this.$route.name === 'add-permit-to-user') {
        this.backButtons = this.$route.matched.filter(route =>
          route.name !== 'add-permit',
        );
      } else {
        this.backButtons = this.$route.matched;
      }
    },
  },
  created() {
    this.checkRoutes();
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/app.scss';

  .back-button {
    margin-bottom: 30px;
  }

  .el-tag {
    background-color: transparent;
    border-color: transparent;
    margin: 2px;
    color: $grey-five;
    padding: 0 5px;
    line-height: 0;
    height: auto;

    .el-icon-arrow-left {
      margin-left: -7px;
    }

  }

  .el-tag.el-tag--success {
    background-color: transparent;
    border-color: transparent;
    color: $brand-orange;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/BackButton.vue